var _defs, _path, _path2, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTaller(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_20",
    "data-name": "Grupo 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 7.878,
    height: 13.511,
    viewBox: "0 0 7.878 13.511",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_363",
    "data-name": "Rect\\xE1ngulo 363",
    width: 4.505,
    height: 2.382,
    fill: "#f49a3f"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_364",
    "data-name": "Rect\\xE1ngulo 364",
    width: 4.505,
    height: 0.881,
    fill: "#f49a3f"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_365",
    "data-name": "Rect\\xE1ngulo 365",
    width: 7.878,
    height: 11.129,
    fill: "#f49a3f"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_44",
    "data-name": "Trazado 44",
    d: "M39.959,125.4a.184.184,0,0,0,.182-.188v-.182a.19.19,0,0,0-.182-.194H37.132a.189.189,0,0,0-.182.194v.182a.184.184,0,0,0,.182.188Z",
    transform: "translate(-34.609 -114.394)",
    fill: "#f49a3f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_45",
    "data-name": "Trazado 45",
    d: "M39.959,126.391a.189.189,0,0,0,.182-.194v-.176a.186.186,0,0,0-.182-.194H37.132a.186.186,0,0,0-.182.194v.176a.189.189,0,0,0,.182.194Z",
    transform: "translate(-34.609 -114.558)",
    fill: "#f49a3f"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12",
    "data-name": "Grupo 12",
    transform: "translate(1.842 11.129)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_14",
    "data-name": "Grupo 14",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_38",
    "data-name": "Trazado 38",
    d: "M39.959,127.382a.189.189,0,0,0,.182-.194v-.182a.185.185,0,0,0-.182-.188H37.132a.184.184,0,0,0-.182.188v.182a.189.189,0,0,0,.182.194Z",
    transform: "translate(-36.451 -125.851)",
    fill: "#f49a3f"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13",
    "data-name": "Grupo 13",
    transform: "translate(1.842 12.631)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16",
    "data-name": "Grupo 16",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_39",
    "data-name": "Trazado 39",
    d: "M39.609,127.838a1.045,1.045,0,0,1-.932.558,1.079,1.079,0,0,1-.933-.558Z",
    transform: "translate(-36.582 -127.521)",
    fill: "#f49a3f"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_14-2",
    "data-name": "Grupo 14",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18",
    "data-name": "Grupo 18",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40",
    "data-name": "Trazado 40",
    d: "M38.082,112.335a3.861,3.861,0,0,0-3.937,3.778A3.786,3.786,0,0,0,34.668,118a9.69,9.69,0,0,1,1.384,3.513c.129.763.311.939.916.939H39.2c.6,0,.786-.176.916-.939A9.69,9.69,0,0,1,41.5,118a3.786,3.786,0,0,0,.523-1.889,3.861,3.861,0,0,0-3.937-3.778",
    transform: "translate(-34.145 -112.328)",
    fill: "#f49a3f"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaller);
export default __webpack_public_path__ + "static/media/taller.1f044cbbeb297ea450efc38ac02834b4.svg";
export { ForwardRef as ReactComponent };